import { Message } from 'primeng/primeng';
import { AuthService } from './../../services/auth.service';
import { StoreService } from './../../services/store.service';
import { FormBuilder } from '@angular/forms';
import { CommandeService } from './../../services/commande.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  login: string;
  password: string;
  currentUser: any;
  msgs: Message[] = [];
  displaychargement = true;
  environment = environment;
  responseCaptcha: string = "";
  recaptcha ;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: StoreService,
    private formBuilder: FormBuilder,
    private authService: AuthService) { }

  ngOnInit() {
    sessionStorage.clear();
    this.store.logOut();

    setTimeout(
        () => {
          if((window as any).grecaptcha){
        this.recaptcha = (window as any).grecaptcha;
      } else {
        console.error('reCAPTCHA not loaded');
      }
      this.displaychargement = false
        },
        2000
      );

    
    this.displaychargement = false;
  }


  async connexion() {
    console.log('in connexion !!!');
    this.displaychargement = true;
    if (!this.verifyCaptcha()) {
      this.displaychargement = false;
      return;
    }
    try {
      this.currentUser = await this.authService.login({ login: this.login, password: this.password }).toPromise();
      this.store.setValue('user', this.currentUser.agent);
      this.store.setValue('accessToken', this.currentUser.token);
      this.store.setValue('login', this.currentUser.agent.login);
      console.log('this.store.setItem: ', this.store.getItem('user'));
      console.log('this.store.accessToken: ', this.store.getItem('accessToken'));
      let allUserCode = '';
      console.log('this.currentUser: ', this.currentUser);
      this.currentUser.agent.profil.listDroit.forEach(e => {
        console.log('code: ', e.code);
        allUserCode += e.code + ";";
      });
      this.authService.allUserCode = allUserCode;
      console.log('allUserCode: ', allUserCode);
      this.store.setValue('allUserCode', allUserCode);
      sessionStorage.setItem("SESSION_RELAD_FIRST", "OK");
      sessionStorage.setItem("SESSION_TAUX_ECHANGE",this.currentUser.tauxEchange);
      sessionStorage.setItem("SESSION_TAUX_ECHANGE_PUE",this.currentUser.tauxEchangePue);
      // this.router.navigate(['/root/accueil']);
      window.location.href = '#/root/accueil';
      window.location.reload();
    } catch (error) {
      console.log('errrrrorrr: ', error);
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'Erreur', detail: 'Login ou mot de passe incorrecte !!!' });
    } finally {
      this.displaychargement = false;
    }
  }

  showResponse(event) {
    // console.log(JSON.stringify(event));
    this.responseCaptcha = event.response;
    console.log('notre reponse captcha ', this.responseCaptcha);
  }
  onExpire(){
    this.responseCaptcha="";
  }

  verifyCaptcha() {
    // return true;
    if (this.responseCaptcha.length > 10) {
      return true;
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'error', detail: 'Veuillez valider le Captcha !' });
      return false;
    }
  }
}
